import { runtimeEnv } from './runtimeEnv';

const DEFAULT_LINKEDIN_PROFILE_URL = 'https://www.linkedin.com/company/palen-adr-ia';

function normalizeSocialProfileUrl(url: string | undefined) {
  const trimmedUrl = String(url || '').trim();

  if (!trimmedUrl) {
    return DEFAULT_LINKEDIN_PROFILE_URL;
  }

  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl;
  }

  return `https://${trimmedUrl}`;
}

export const publicSocialLinks = {
  linkedinProfileUrl: normalizeSocialProfileUrl(runtimeEnv.VITE_LINKEDIN_PROFILE_URL),
};
